import { Color } from "cesium";
import { getDefaultControlLineSettings, getDefaultPolylineSettings, } from "../../settings/earthbrain-site-settings";
import { ELongitudinalSlopeType, ERubbingDestination, } from "./types";
import { AssetType, } from "../../types";
import { PathSlopeType, } from "../mid-path/interface";
import { getAlignmentDataFromControlPointsAndSegments } from "../../utilities/alignment-adapter-utils";
async function fromTrenchData_Version1(jsonstr) {
    const json = JSON.parse(jsonstr);
    const trenchId = json.trenchId;
    const trenchSettings = TrenchSavedData.fillEmptyByDefaultTrenchSetting(json.trenchSettings);
    if (!json.associatePointCloudId && !json.associateDrawing2dImageId) {
        throw new Error("Trench data must have either associatePointCloudId or associateDrawing2dImageId");
    }
    const { surveyPoints, ipPointIds, horizontalAlignmentData, verticalAlignmentData, } = await getAlignmentDataFromControlPointsAndSegments(json);
    return {
        trenchId,
        trenchSettings,
        associatedTerrain: json.associatePointCloudId
            ? {
                id: json.associatePointCloudId,
                terrainType: AssetType.Point_Cloud,
            }
            : {
                id: json.associateDrawing2dImageId,
                terrainType: AssetType.REFERENCE_TOPOLOGY,
            },
        rubbingDestination: json.associatePointCloudId
            ? {
                target: ERubbingDestination.POINT_CLOUD,
                id: json.associatePointCloudId,
            }
            : {
                target: ERubbingDestination.REFERENCE_TOPOLOGY,
                id: json.associateDrawing2dImageId,
            },
        surveyPoints,
        ipPointIds,
        horizontalAlignment: horizontalAlignmentData,
        verticalAlignment: verticalAlignmentData,
    };
}
async function fromTrenchData_Version2(jsonstr) {
    const json = JSON.parse(jsonstr);
    const trenchId = json.trenchId;
    const trenchSettings = TrenchSavedData.fillEmptyByDefaultTrenchSetting(json.trenchSettings);
    const { surveyPoints, ipPointIds, horizontalAlignmentData, verticalAlignmentData, } = await getAlignmentDataFromControlPointsAndSegments(json);
    return {
        trenchId,
        trenchSettings,
        associatedTerrain: {
            id: json.associatedTerrain.id,
            terrainType: json.associatedTerrain.terrainType,
        },
        rubbingDestination: json.rubbingDestination,
        surveyPoints,
        ipPointIds,
        horizontalAlignment: horizontalAlignmentData,
        verticalAlignment: verticalAlignmentData,
    };
}
export var TrenchSavedData;
(function (TrenchSavedData) {
    function fillEmptyByDefaultTrenchSetting(trenchSetting) {
        const fillCommonSettings = (trenchCommonSetting) => {
            const pathCommonSetting = {
                color: trenchCommonSetting.path.color ?? "#964B00",
                specifiedElevation: trenchCommonSetting.path.specifiedElevation ?? 1.0,
                transparency: trenchCommonSetting.path.transparency ?? 1,
                leftWidth: trenchCommonSetting.path.leftWidth ?? 2.5,
                rightWidth: trenchCommonSetting.path.rightWidth ?? 2.5,
                interpolationPitch: trenchCommonSetting.path.interpolationPitch ?? 5,
                outline: trenchCommonSetting.path.outline ?? true,
                outlineColor: trenchCommonSetting.path.outlineColor ?? Color.BLACK,
                controlLineSettings: trenchCommonSetting.path.controlLineSettings ??
                    getDefaultControlLineSettings(),
                polyLineSettings: trenchCommonSetting.path.polyLineSettings ??
                    getDefaultPolylineSettings(),
                longitudinalSlope: trenchCommonSetting.path.longitudinalSlope || {
                    slopeType: ELongitudinalSlopeType.DEFAULT,
                },
                referencePointElevation: trenchCommonSetting.path.referencePointElevation,
            };
            const pathWithTrenchSlope = {
                ...pathCommonSetting,
            };
            pathWithTrenchSlope.trenchSlopeType =
                trenchCommonSetting.path.trenchSlopeType ?? PathSlopeType.CROSS;
            if (pathWithTrenchSlope.trenchSlopeType === PathSlopeType.CROSS) {
                pathWithTrenchSlope.leftSlope =
                    trenchCommonSetting.path.leftSlope ??
                        50;
                pathWithTrenchSlope.rightSlope =
                    trenchCommonSetting.path.rightSlope ??
                        50;
            }
            else if (pathWithTrenchSlope.trenchSlopeType === PathSlopeType.STRAIGHT) {
                pathWithTrenchSlope.slope =
                    trenchCommonSetting.path.slope ?? 50;
            }
            const commonSetting = {
                path: pathWithTrenchSlope,
                cutSetting: {
                    generateShelf: trenchCommonSetting.cutSetting.generateShelf ?? true,
                    left: {
                        slopeHeight: trenchCommonSetting.cutSetting.left.slopeHeight ?? 5,
                        moundSlope: trenchCommonSetting.cutSetting.left.moundSlope ?? 1.5,
                        shelfWidth: trenchCommonSetting.cutSetting.left.shelfWidth ?? 1.5,
                        shelfSlope: trenchCommonSetting.cutSetting.left.shelfSlope ?? 100,
                    },
                    right: {
                        slopeHeight: trenchCommonSetting.cutSetting.right.slopeHeight ?? 5,
                        moundSlope: trenchCommonSetting.cutSetting.right.moundSlope ?? 1.5,
                        shelfWidth: trenchCommonSetting.cutSetting.right.shelfWidth ?? 1.5,
                        shelfSlope: trenchCommonSetting.cutSetting.right.shelfSlope ?? 100,
                    },
                    color: trenchCommonSetting.cutSetting.color ?? "#FFA500",
                    transparency: trenchCommonSetting.cutSetting.transparency ?? 1,
                },
                // destination,
            };
            return commonSetting;
        };
        const commonSetting = fillCommonSettings(trenchSetting.commonSetting);
        const trenchSettings = { commonSetting };
        return trenchSettings;
    }
    TrenchSavedData.fillEmptyByDefaultTrenchSetting = fillEmptyByDefaultTrenchSetting;
    async function parseTrenchSavedData(jsonString) {
        let trenchData;
        const jsonData = JSON.parse(jsonString);
        switch (jsonData.version) {
            case undefined:
                break;
            case 1.0:
                trenchData = await fromTrenchData_Version1(jsonString);
                break;
            case 2.0:
                trenchData = await fromTrenchData_Version2(jsonString);
                break;
            default:
                throw new Error(`Unknown trench data version: ${jsonData.version}`);
        }
        return trenchData;
    }
    TrenchSavedData.parseTrenchSavedData = parseTrenchSavedData;
})(TrenchSavedData || (TrenchSavedData = {}));
//# sourceMappingURL=trenchData.js.map